<script>

import bdlogo from '../assets/bodum.svg';

import p1_img1 from '../assets/p-imgs/p1/p1_img1.png';
import p1_img2 from '../assets/p-imgs/p1/p1_img2.jpg';
import p1_img3 from '../assets/p-imgs/p1/p1_img3.jpg';
import p1_img4 from '../assets/p-imgs/p1/p1_img2.jpg';
import p1_img5 from '../assets/p-imgs/p1/p1_img1.png';


import p2_img1 from '../assets/p-imgs/p2/p2_img1.png';
import p2_img2 from '../assets/p-imgs/p2/p2_img2.jpg';
import p2_img3 from '../assets/p-imgs/p2/p2_img3.jpg';
import p2_img4 from '../assets/p-imgs/p2/p2_img2.jpg';
import p2_img5 from '../assets/p-imgs/p2/p2_img1.png';


import p3_img1 from '../assets/p-imgs/p3/p3_img1.png';
import p3_img2 from '../assets/p-imgs/p3/p3_img2.jpg';
import p3_img3 from '../assets/p-imgs/p3/p3_img3.jpg';
import p3_img4 from '../assets/p-imgs/p3/p3_img2.jpg';
import p3_img5 from '../assets/p-imgs/p3/p3_img1.png';


import p4_img1 from '../assets/p-imgs/p4/p4_img1.png';
import p4_img2 from '../assets/p-imgs/p4/p4_img2.jpg';
import p4_img3 from '../assets/p-imgs/p4/p4_img3.jpg';
import p4_img4 from '../assets/p-imgs/p4/p4_img2.jpg';
import p4_img5 from '../assets/p-imgs/p4/p4_img1.png';


import p5_img1 from '../assets/p-imgs/p5/p5_img1.png';
import p5_img2 from '../assets/p-imgs/p5/p5_img2.jpg';
import p5_img3 from '../assets/p-imgs/p5/p5_img3.jpg';
import p5_img4 from '../assets/p-imgs/p5/p5_img2.jpg';
import p5_img5 from '../assets/p-imgs/p5/p5_img1.png';


import p6_img1 from '../assets/p-imgs/p6/p6_img1.png';
import p6_img2 from '../assets/p-imgs/p6/p6_img2.jpg';
import p6_img3 from '../assets/p-imgs/p6/p6_img3.jpg';
import p6_img4 from '../assets/p-imgs/p6/p6_img4.jpg';
import p6_img5 from '../assets/p-imgs/p6/p6_img1.png';


import p7_img1 from '../assets/p-imgs/p7/p7_img1.png';
import p7_img2 from '../assets/p-imgs/p7/p7_img2.jpg';
import p7_img3 from '../assets/p-imgs/p7/p7_img3.jpg';
import p7_img4 from '../assets/p-imgs/p7/p7_img2.jpg';
import p7_img5 from '../assets/p-imgs/p7/p7_img1.png';


import p8_img1 from '../assets/p-imgs/p8/p8_img1.png';
import p8_img2 from '../assets/p-imgs/p8/p8_img2.jpg';
import p8_img3 from '../assets/p-imgs/p8/p8_img3.jpg';
import p8_img4 from '../assets/p-imgs/p8/p8_img2.jpg';
import p8_img5 from '../assets/p-imgs/p8/p8_img1.png';

import aw1 from '../assets/logo-da.svg';
import aw2 from '../assets/logo-gda.svg';



// import share2Src from '../assets/share-02.svg';

export default {
    
    data(){
        return {
            s_logo_svg: `<svg version="1.1" id="圖層_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 132.5 80.4" style="enable-background:new 0 0 132.5 80.4;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#14227F;}
	.st1{fill:#FFFFFF;}
</style>
<path class="st0" d="M127.5,80.4H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h122.5c2.7,0,5,2.2,5,5v70.4
	C132.5,78.1,130.3,80.4,127.5,80.4z"/>
<g>
	<path class="st1" d="M78.6,34.2L66.3,50.7L54,34.2l-6.6,5.2c0,0,13,17.2,15.4,20.1c1,1.2,2.2,1.8,3.5,1.8c1.3,0,2.5-0.6,3.5-1.8
		c2.4-2.9,15.4-20.1,15.4-20.1L78.6,34.2z"/>
	<path class="st1" d="M66.3,21.5l26.2,39.9l6.1-6.7L69.7,11.9c-0.8-1.1-2.1-1.8-3.4-1.8c-1.4,0-2.6,0.7-3.4,1.8L34,54.7l6.1,6.7
		L66.3,21.5z"/>
	<path class="st1" d="M66.3,8.7c-21.8,0-39.4,14.1-39.4,31.5c0,17.4,17.6,31.5,39.4,31.5c21.8,0,39.4-14.1,39.4-31.5
		C105.7,22.8,88,8.7,66.3,8.7 M66.3,67.8c-19.1,0-34.7-12.4-34.7-27.6c0-15.2,15.6-27.6,34.7-27.6c19.1,0,34.7,12.4,34.7,27.6
		C100.9,55.4,85.4,67.8,66.3,67.8"/>
</g>
</svg>`,
            bdlogo,
            all_ps: [
                {
                    pd_id: "pd00",
                    name: "儲物罐<span>600cc</span>",
                    brand_imgs: 0,
                    text1: "<span>60</span>枚＋$69",
                    text2: "<span>20</span>枚＋$229",
                    bluetext: "或扣800點福利點<span>＋$229馬上換</span>",
                    price_text: "市價$1,280<span>(紅/白隨機出貨，不可挑選)</span>",
                    des: "寬口徑設計的儲存罐，不論是零食或是咖啡粉皆可輕鬆儲存。罐身使用可回收材質搭配矽膠防滑圈，設計簡約中帶點時尚，屬於Bodum的經典北歐風格。",
                    imgs: [ {url: p1_img1, is_video: 0}, {url: p1_img2, is_video: 0}, {url: p1_img3, is_video: 0}],
                    links: [ p1_img1, p1_img2, p1_img3]
                },
                {
                    pd_id: "pd01",
                    name: "不鏽鋼真空隨行杯<span>0.35L</span>",
                    brand_imgs: 0,
                    text1: "<span>60</span>枚＋$399",
                    text2: "<span>20</span>枚＋$549",
                    bluetext: "或扣800點福利點<span>＋$549馬上換</span>",
                    price_text: "市價$1,690  <span>(紅/黑隨機出貨，不可挑選)</span>",
                    des: "真空的不鏽鋼設計，杯身配以符合人體工學的矽膠圈，好握、好拿方便帶著走，防滑橡膠底座使您放置時不易翻倒。",
                    imgs: [ {url: p2_img1, is_video: 0}, {url: p2_img2, is_video: 0}, {url: p2_img3, is_video: 0} ],
                    links: [ p2_img1, p2_img2, p2_img3 ]
                },
                {
                    pd_id: "pd02",
                    name: "雙層玻璃杯<span>250cc(2入/組)</span>",
                    brand_imgs: [aw1, 0],
                    text1: "<span>60</span>枚＋$499",
                    text2: "<span>20</span>枚＋$649",
                    bluetext: 0,
                    price_text: "市價$2,580",
                    des: "專業工匠手工吹造、杯底專利矽膠氣孔，堪稱「會呼吸」的雙層玻璃杯。雙層設計可高效隔絕空氣，使外層玻璃壁不易產生水珠，透明無色的玻璃杯不論是盛裝飲品或是擺放點心都合適。",
                    imgs: [ {url: p3_img1, is_video: 0}, {url: p3_img2, is_video: 0}, {url: p3_img3, is_video: 0}],
                    links: [ p3_img1, p3_img2, p3_img3]
                },
                {
                    pd_id: "pd03",
                    name: "哥本哈根保溫瓶<span>1.1L</span>",
                    brand_imgs: [0, aw2],
                    text1: "<span>60</span>枚＋$749",
                    text2: "<span>20</span>枚＋$899",
                    bluetext: 0,
                    price_text: "市價$3,580",
                    des: "Bodum經典長銷款，真空密封的雙層不鏽鋼內膽，使飲品可長時間維持溫度，流線型瓶身設計加上單手按壓開啟上蓋，讓保溫瓶不僅是居家用品，更是藝術品。",
                    imgs: [ {url: p4_img1, is_video: 0}, {url: p4_img3, is_video: 0}, {url: p4_img2, is_video: 0}],
                    links: [ p4_img1, p4_img3, p4_img2]
                },
                {
                    pd_id: "pd04",
                    name: "美式濾滴咖啡機",
                    brand_imgs: 0,
                    text1: "<span>70</span>枚＋$1,250",
                    text2: "<span>25</span>枚＋$1,600",
                    bluetext: "或扣1000點福利點<span>＋$1,600馬上換</span>",
                    price_text: "市價:$3,990",
                    des: "擁有美式咖啡的低調質感，也同時具有Bodum對於咖啡的堅持，咖啡機獨特的噴頭設計，使熱水更均勻的撒在咖啡粉上，媲美職人手沖口感。此外，配有金屬濾網可直接使用免濾紙、預約定時功能簡單設定即可品嘗咖啡香醇風味。",
                    imgs: [ {url: p5_img1, is_video: 0}, {url: p5_img2, is_video: 0}, {url: p5_img3, is_video: 0}, {url: p5_img2, is_video: 1}],
                    links: [ p5_img1, p5_img2, p5_img3, "https://www.youtube.com/embed/T7lHDVo9P3U?mute=1&enablejsapi=1&version=3&playerapiid=ytplayer&playsinline=1"]
                },
                {
                    pd_id: "pd05",
                    name: "鬆餅機",
                    brand_imgs: 0,
                    text1: "<span>70</span>枚＋$1,490",
                    text2: "<span>25</span>枚＋$1,840",
                    bluetext: 0,
                    price_text: "市價:4,690",
                    des: "五段溫度設定，不僅可烤出完美鬆餅，也可依喜好製作馬鈴薯餅、起士餅及蛋餅等。不易沾黏的烤盤方便清潔，機身底部配有隱藏式電源線收納，外型時尚宛如餐桌上的家飾品。",
                    imgs: [ {url: p6_img1, is_video: 0}, {url: p6_img2, is_video: 0}, {url: p6_img3, is_video: 0}, {url: p6_img4, is_video: 0}],
                    links: [ p6_img1, p6_img2, p6_img3, p6_img4]
                },
                {
                    pd_id: "pd06",
                    name: "多段式磨豆機",
                    brand_imgs: [aw1, aw2],
                    text1: "<span>70</span>枚＋$1,990",
                    text2: "<span>25</span>枚＋$2,340",
                    bluetext: 0,
                    price_text: "市價:$6,680",
                    des: "專業級錐形研磨刀盤搭載12段模式溫柔均勻研磨，滿足您從義式咖啡至法式濾壓壺的咖啡研磨需求！專業級的磨豆機是身為咖啡愛好者的你，絕對不可缺少的好幫手。",
                    imgs: [ {url: p7_img1, is_video: 0}, {url: p7_img3, is_video: 0}, {url: p7_img2, is_video: 0}, {url: p7_img1, is_video: 1}],
                    links: [ p7_img1, p7_img3, p7_img2, "https://www.youtube.com/embed/RO9JVkkeylM?mute=1&enablejsapi=1&version=3&playerapiid=ytplayer&playsinline=1"]
                },
                {
                    pd_id: "pd07",
                    name: "電動虹吸式咖啡壺",
                    brand_imgs: [0, aw2],
                    text1: "<span>70</span>枚＋$3,990",
                    text2: "<span>25</span>枚＋$4,380",
                    bluetext: 0,
                    price_text: "市價:$12,900<span>(限量18,000台)</span>",
                    des: "專業級虹吸式咖啡也可以很簡單，採電熱式加熱，使咖啡製作時間和溫度完美校準、確保每杯咖啡的風味。下壺使用安全PC材質，除符合國內食品器具衛生標準，更符合歐盟最新法規檢測合格、強化商品耐用程度！",
                    imgs: [ {url: p8_img1, is_video: 0}, {url: p8_img3, is_video: 0}, {url: p8_img2, is_video: 0}, {url: p8_img1, is_video: 1}, {url: p8_img2, is_video: 1}],
                    links: [ p8_img1, p8_img3, p8_img2, "https://www.youtube.com/embed/YuGCGoKoSKQ?mute=1&enablejsapi=1&version=3&playerapiid=ytplayer&playsinline=1", "https://www.youtube.com/embed/hoIxhEpra3g?mute=1&enablejsapi=1&version=3&playerapiid=ytplayer&playsinline=1"]
                }
            ]
        }
    },
    props: ['id'],
    methods: {
        play(video){
            $('#'+video)[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        },
        pause(){
            let video_count = $(".product-intro iframe").length;

            for(let i=0;i<video_count;i++){
                $('.yt-video')[i].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
            }
        },
        reg(str){
            return (str.match(/embed/)!==null)?0:1;
        },


        slider_nav($nav, $for){
            $($nav).slick({
                slidesToShow: 4,
                //slidesToScroll: 1,
                asNavFor: $for,
                //infinite: false,
                //dots: true,
                //centerMode: true,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 2
                        }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ]
            });
        },
        slider_for($nav, $for){
            $($for).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                asNavFor: $nav
            });
        },
        light_box($for){
            $($for).slickLightbox({
                itemSelector        : 'a',
                navigateByKeyboard  : true
            });

        },
        after_change($for){
            $($for).on('afterChange', (event, slick, cur)=>{
                //alert( $(slick.$slides[cur]).find('iframe').attr('id') );
                this.pause();
                let type = $(slick.$slides[cur]).find('iframe').data('type');
                let id = $(slick.$slides[cur]).find('iframe').attr('id');
                //console.log(type+id)
                
                if(type==="video"){
                    this.play(id);
                    setTimeout(()=>{
                        this.play(id);
                    },100)
                    setTimeout(()=>{
                        this.play(id);
                    },200)
                    setTimeout(()=>{
                        this.play(id);
                    },300)
                    setTimeout(()=>{
                        this.play(id);
                    },400)
                    setTimeout(()=>{
                        this.play(id);
                    },500)
                    setTimeout(()=>{
                        this.play(id);
                    },600)

                }
            });
        },
        run_all_slide($nav, $for){
            this.slider_nav($nav, $for);
            this.slider_for($nav, $for);
            this.light_box($for);
            this.after_change($for);
        },
        filter(array){
            let pds = [];

            if(this.id === undefined){
                return array;
            }else{
                pds.push(array[this.id]);
                return pds;
            }
            //return (this.id === undefined)?array:pds;
        },
        ga_func(class_name, name){
            $(class_name).on('click', function (e) {
                gtag('event', '點擊', {
                    'event_category': name,
                    'event_action': '點擊',
                    'event_label': '點擊次數'
                });
            });
        },
		pd_fb_share(id, pd_id){

            //console.log(this.$route.name);
            console.log(pd_id);

            var o_s = window.location.href;

            var hash_p = o_s.indexOf("#");
            //console.log(hash_p);
            var n_s = o_s.slice(0, hash_p+2);
            //console.log(n_s);
            var s = n_s.replace('#', '?pd_id='+pd_id+'#');
            //var s = window.location.href;
            //console.log(s);
            if(this.$route.name=='products'){
                window.open('http://www.facebook.com/share.php?u=' + encodeURIComponent(o_s));
            }else{
                window.open('http://www.facebook.com/share.php?u=' + encodeURIComponent(s) + 'products/' + id);
            }

            
		},
		pd_line_share(id, pd_id){
            //e.preventDefault();

            //var path = "http://test.moveon-design.com/pxmart-event/#/";
            var o_s = window.location.href;

            var hash_p = o_s.indexOf("#");
            //console.log(hash_p);
            var n_s = o_s.slice(0, hash_p+2);
            //console.log(n_s);
            var s = n_s.replace('#', '?pd_id='+pd_id+"#");
            
            // var x = this.href.substr(this.href.lastIndexOf('/') + 1);
            // var i = s.indexOf(x);

            // s = s.substring(0, i);
            
            if(this.$route.name=='products'){
                window.open('https://social-plugins.line.me/lineit/share?url=' + o_s);

            }else{
                var link = `https://social-plugins.line.me/lineit/share?url=${s}products/${id}`;

                window.open(link);
            }
			// $(".allshare-line-btn").on("click", function (e) {
				
			// });
		}
    },
    computed: {
        random_num(){
            let max = 2000;
            let min = 1;
            return Math.floor(Math.random()*(max-min+1))+min;

        }
    },
    mounted(){
        let p_count = this.all_ps.length;
        for(let i=0;i<p_count;i++){
            this.run_all_slide(`.slider-nav${i+1}`,`.slider-for${i+1}`);
        }

        if(this.$route.name == 'product-intro'){
            setTimeout(()=>{
                $("HTML, BODY").animate({ scrollTop: $("#product-intro").offset().top }, 500);
                
            },500);
            
        }

        this.all_ps.forEach((el)=>{
            this.ga_func(".line_"+el.pd_id ,el.name+"-line分享");
            this.ga_func(".fb_"+el.pd_id ,el.name+"-fb分享");
            //console.log(el.name)
        });



        if(this.$route.name=="products"){


			$("#product-intro").css({
				"margin-bottom": 0,
				"margin-top": "90px"
            });

            $("#product-intro .bg").addClass("inner-bg");

		}
        console.log("pdIntro!!")


        let url = window.location.href;
        let n_url = url.replace("og_id", "pd_id");
        //window.location.href = n_url;
        //console.log(n_url);
        window.history.pushState("test","test", n_url);






        
        
    },
    created(){
        
    }
}

</script>

<template>
    <section class="product-intro" id="product-intro">
        <div class="bg" v-if=id></div>
        <div class="container pd-container">
            <div class="row">
                <div class="col-12">
                    <div class="title-wrap">
                        <h1 class="title">商品介紹</h1>
                    </div>
                </div>
            </div>
            <div class="row pd-row" v-for="(pd, index) in filter(all_ps)">
                <div class="col-12 col-lg-6 order-lg-6">
                    <div class="content-wrap-outer">
                        <div class="content-wrap">
                            <div class="logo-wrap">
                                <img :src="bdlogo" alt="">
                            </div>

                            <h1 class="p-name" v-html="pd.name"></h1>

                            <div class="award-line" v-if="pd.brand_imgs">
                                <div class="aw2" v-if="pd.brand_imgs[1]">
                                    <img :src="pd.brand_imgs[1]" alt="">
                                </div>
                                <div class="aw1" v-if="pd.brand_imgs[0]">
                                    <img :src="pd.brand_imgs[0]" alt="">
                                </div>
                            </div>
                            <div class="line1">
                                <div class="text1" v-html="pd.text1"></div>
                                <div class="text2" v-html="pd.text2"></div>
                            </div>
                            <div class="line2" v-if="pd.bluetext">
                                <div class="s-logo" v-html="s_logo_svg"></div>
                                <span v-html="pd.bluetext"></span>
                            </div>
                            <p class="price-text" v-html="pd.price_text"></p>
                            <p class="p-content">
                                {{pd.des}}
                            </p>
                            <div class="share-links">
                                <a href="" class="line" @click.prevent="pd_line_share(index, pd.pd_id)">
                                    <img src="../assets/share-01.svg" alt="">
                                </a>
                                <!-- pd.pd_id -->
                                <a href="" class="fb" @click.prevent="pd_fb_share(index, pd.pd_id)">
                                    <img src="../assets/share-02.svg" alt="">
                                </a>
                            </div>
                            <div class="photo-slide">
                                <div :class="`slider-nav slider-nav${index+1}`">
                                    <div class="img-wrap" v-for="img in pd.imgs">
                                        <img :src="img.url" alt="">
                                        <!-- <div class="img"
                                            :style="`background-image:url(${img.url})`"
                                        ></div> -->
                                        <img class="play-btn" v-if="img.is_video" src="../assets/play-btn.png" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div class="slider-for-outer">
                        <div :class="`slider-for slider-for${index+1}`">
                            <div class="img-wrap" v-for="(img, id) in pd.links">
                                <template v-if="reg(img)">
                                    <a :href="img">
                                        <img :src="img" alt="">
                                    </a>
                                </template>
                                <template v-else>
                                    <a :href="img" class="video-class">
                                        <div class="video-wrap">
                                            <iframe 
                                                class="yt-video" 
                                                data-type="video" 
                                                :id="`video${index*index*id}`" 
                                                :src=img 
                                                frameborder="0" 
                                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                                                allowfullscreen>
                                            </iframe>
                                        </div>
                                    </a>
                                </template>
                            </div>
                        </div>
                        
                        
            
                    </div>
                    <div class="share-links-m">
                        <a href="" class="line" @click.prevent="pd_line_share(index, pd.pd_id)">
                            <img src="../assets/share-01.svg" alt="">
                        </a>
                        <!-- pd.pd_id -->
                        
                        <a href="" class="fb" @click.prevent="pd_fb_share(index, pd.pd_id)">
                            <img src="../assets/share-02.svg" alt="">
                        </a>
                        <!-- <a href="https://social-plugins.line.me/lineit/share?url=http://test.moveon-design.com/bodum/?pd_id=pd03#/products/3">test</a> -->
                    </div>
                </div>
            </div>

        </div>
    </section>
</template>

<style lang="sass">

@import "~styles/global.sass"

//$red: #ce1d1b
*
    //border: 1px solid
button.slick-arrow
    z-index: 100



    
.product-intro
    margin-top: 100px
    margin-bottom: 80px
    @media (max-width: 991px)
        margin-top: 0
        margin-bottom: 70px
    @media (max-width: 576px)
        padding: 50px 30px
    @media (max-width: 450px)
        padding: 50px 20px

    .bg
        background-image: url('../assets/product-bg.png')
        position: fixed
        display: block
        top: 0
        left: 0
        width: 100%
        height: 100%
        background-size: cover
        background-position: center center
        transform: translateZ(0)
        will-change: transform
        z-index: -1001
    
    .inner-bg
        background-image: url('../assets/qna-bg.png') !important
        
    
    .pd-container
        position: relative
        @media (max-width: 991px)
            padding-left: 50px
            padding-right: 50px
        @media (max-width: 450px)
            padding-left: 15px
            padding-right: 15px
        &:before
            content: ''
            position: absolute
            //display: none
            width: 100%
            height: 100%
            top: 0
            left: 0
            background: white
            //box-shadow: 0 1px 10px rgba(black, 0.1)
            border-radius: 20px
            opacity: 0.65
            @media (max-width: 991px)
                display: block
                box-shadow: 0 1px 10px rgba(black, 0.1)
                opacity: 1

    .title-wrap
        text-align: center
        padding-top: 60px
        padding-bottom: 60px
        @media (max-width: 991px)
            padding-top: 60px
            padding-bottom: 60px
        @media (max-width: 576px)
            padding-top: 40px
            padding-bottom: 0px
        .title
            color: black
    

    .pd-row
        padding-bottom: 100px
        position: relative
        @media (max-width: 991px)
            margin-top: 30px
        &:before
            content: ""
            position: absolute
            display: none
            width: 100%
            height: 1px
            background: rgba(black, 0.2)
            bottom: 28px
            left: 50%
            transform: translateX(-50%)
            @media (max-width: 991px)
                display: block
            @media (max-width: 576px)
                width: 85%
        &:last-child
            &:before
                display: none
        @media (max-width: 768px)
            padding-bottom: 100px
    .content-wrap-outer
        height: 100%
        display: flex
        align-items: center
        justify-content: center
        padding: 15px
        .content-wrap
            width: 100%
            @media (max-width: 991px)
                font-size: 18px
            @media (max-width: 768px)
                font-size: 16px
            .logo-wrap
                margin-bottom: 10px
                img
                    width: 30%
                    min-width: 150px
                @media (max-width: 991px)
                    text-align: left
            .share-links
                a
                    display: inline-block
                    width: 80px
                    img
                        width: 100%
            .p-name
                margin-bottom: 25px
                span
                    font-size: 22px
                    display: inline-block
                @media (max-width: 991px)
                    text-align: left

            .line1
                margin-bottom: 20px
                @media (max-width: 576px)
                    display: flex
                div
                    display: inline-block
                    white-space: nowrap
                    span
                        padding: 8px 10px
                        display: inline-block
                        background: black
                        border-radius: 5px
                        margin-right: 5px
                        color: white
                        @media (max-width: 576px)
                            padding: 6px 8px
                

                .text1
                    margin-right: 20px
                    @media (max-width: 576px)
                        margin-right: 5px
                .text1,.text2
                    cursor: pointer
                    transition: .3s
                    span
                        font-size: 20px
                    @media (max-width: 350px)
                        font-size: 14px
                        letter-spacing: 0px
                    &:hover
                        color: $red 
                        span
                            transition: .3s
                            background: $red
                
            .line2
                color: #0f2a85
                margin-bottom: 10px
                display: flex
                //justify-content: center
                align-items: center
                .s-logo
                    display: inline-block
                    //width: 40px
                    vertical-align: middle
                    margin-right: 5px
                    //padding-bottom: 56.25%
                    //border: 1px solid
                    width: 12%
                    max-width: 40px
                    @media (max-width: 576px)
                        height: 40px
                        min-width: 60px
                        position: relative
                        //left: -8px


                    svg
                span
                    display: inline-block
                        //width: 
            .award-line
                margin-bottom: 15px
                .aw1
                    img
                        width: 150px
                .aw2
                    margin-bottom: 10px
                    img
                        width: 41px
                
            .price-text
                font-weight: 300
                span
                    color: $red
                    display: inline-block
            .share-links
                margin-bottom: 20px
                @media (max-width: 991px)
                    display: none
                a
                    margin-right: 20px
            
            .photo-slide
                .slider-nav
                    .slick-track
                        margin-left: 0
                    .img-wrap
                        cursor: pointer
                        position: relative
                        //width: 100%
                        //padding-bottom: 33%
                        //overflow: hidden
                        img
                            width: 100%
                            border: 1px solid transparent
                            background-size: cover
                            //position: absolute
                            background-position: center center
                            height: 100%
                            //margin: 10px
                            transform: scale(0.88)
                            transform-origin: center center
                            &:hover
                                border: 1px solid $red
                        .play-btn
                            position: absolute
                            width: 50px
                            height: 50px
                            top: 50%
                            left: 50%
                            transform: translate(-50%, -50%)
                            pointer-events: none

                .slick-next::before
                    color: rgba(black, 0.5)
                    font-family: "Font Awesome 5 Free"
                    font-weight: 900
                    content: "\f0da"
                    font-size: 25px
                .slick-prev::before
                    color: rgba(black, 0.5)
                    font-family: "Font Awesome 5 Free"
                    font-weight: 900
                    content: "\f0d9"
                    font-size: 25px
                .slick-prev 
                    left: -12px
                .slick-next
                    right: -20px 
            .p-content
                font-weight: 400
                text-align: justify
                @media (max-width: 576px)
                    font-weight: 300
                
    .slider-for-outer
        height: 100%
        display: flex
        justify-content: center
        align-items: center
        padding: 15px
        .slider-for
            width: 100%
            // dispaly: flex
            // justify-content: center
            // align-items: center
            .img-wrap
                a
                    display: block
                    height: 100%
                    outline: none
                    
                    
                    .video-wrap
                        padding-bottom: 56.25%
                        position: relative
                        width: 100%

                        //height: 100%
                        iframe
                            position: absolute
                            width: 100%
                            height: 100%
                            top: 50%
                            left: 50%
                            transform: translate(-50%, -50%)
                    img
                        width: 100%
                        margin: 0 auto
                        display: block
                .video-class
                    width: 100%
                    display: flex
                    align-items: center
            .slick-track
                display: flex
                .slick-slide
                    display: flex
                    justify-content: center
                    align-items: center
                    height: auto
                    > div
                        width: 100%
    .share-links-m
        display: none
        text-align: center
        a
            display: inline-block
            width: 80px
            margin: 0 10px
            img
                width: 100%
        @media (max-width: 991px)
            display: block


.slick-lightbox-slick-item-inner
    img
        transform: scale(1.2)
        transform-origin: center center
        @media (max-width: 768px)
            transform: scale(1)
                
                



</style>



// WEBPACK FOOTER //
// src/Index/ProductIntro.vue